
import ProductCard from '@/components/product-card/ProductCard'
import { parseProductFromShopify } from '~/helpers/shopify/product'
import ProductTester from '~/helpers/shopify/tests'
export default {
  components: { ProductCard },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    products: [],
  }),
  async beforeMount() {
    await this.fetchProductsByInternalTypes()
  },
  methods: {
    async fetchProductsByInternalTypes() {
      try {
        if (this.blok.products && this.blok.products.length > 0) {
          const { data } =
            await this.$shopify.product.getProductsByInternalType(
              this.blok.products.map((obj) => obj.internal_type)
            )
          if (data.products.edges.length > 0) {
            const products = []
            data.products.edges.forEach((p) => {
              const product = p.node
              const internalType = product.handle.split('-').pop()
              const productsWithMatchingType = this.blok.products.filter(
                ({ internal_type }) => {
                  return internal_type.toLowerCase() === internalType
                }
              )
              productsWithMatchingType.forEach(({ color }) => {
                let colors = null
                if (color) {
                  colors = [color]
                } else {
                  colors = product.options.find((o) => {
                    return o.name === 'Color'
                  }).values
                }
                colors.forEach((c) => {
                  const test = new ProductTester(product, c, this.$i18n.locale)
                  if (
                    product &&
                    test.productExist() &&
                    test.colorExist() &&
                    test.metafieldsExist() &&
                    test.metafieldsLangExist() &&
                    test.metafieldsColorExist()
                  ) {
                    products.push(
                      parseProductFromShopify(product, this.$i18n.locale, c)
                        .result
                    )
                  }
                })
              })
            })
            this.products = this.reorderProductsList(
              this.blok.products,
              products
            )
          }
        }
      } catch (e) {
        this.$sentryException(e, {
          source: 'Static - List Products',
          level: 'fatal',
          extra: `Static - List Products - fetchProductsByInternalTypes() fail : ${e}`,
        })
      }
    },
    reorderProductsList(baseList, generatedList) {
      const internalTypeMap = {}
      generatedList.forEach((item) => {
        const internalType = item.internal_type
        if (!internalTypeMap[internalType]) {
          internalTypeMap[internalType] = []
        }
        internalTypeMap[internalType].push(item)
      })
      return baseList.flatMap(
        (item) => internalTypeMap[item.internal_type] || []
      )
    },
  },
}
